__turbopack_context__.v({
  "wrapper": "fLa3TG_wrapper",
});
